import { useCallback, useEffect } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIHoverlay from 'UIComponents/overlay/UIHoverlay';
import UIImage from 'UIComponents/image/UIImage';

// @ts-expect-error Untyped import
import QuestionAnswerList from './QuestionAnswerList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Question = ({
  answers,
  id,
  image,
  onSelectAnswer,
  selectedAnswerIds,
  type
}) => {
  const handleSelectAnswer = useCallback(answerId => {
    if (type === 'MULTIPLE_CHOICE_SELECT_MANY') {
      return onSelectAnswer(selectedAnswerIds.includes(answerId) ? selectedAnswerIds.filter(selectedId => selectedId !== answerId) : [...selectedAnswerIds, answerId]);
    }
    return onSelectAnswer([answerId]);
  }, [onSelectAnswer, selectedAnswerIds, type]);
  useEffect(() => {
    const handleKeydown = event => {
      const pressedNumber = parseInt(event.key, 10);
      if (answers.length < 10 && !isNaN(pressedNumber)) {
        const selectedAnswer = answers[pressedNumber - 1];
        if (selectedAnswer) {
          handleSelectAnswer(selectedAnswer.id);
        }
      }
    };
    document.addEventListener('keydown', handleKeydown);
    return () => document.removeEventListener('keydown', handleKeydown);
  }, [answers, handleSelectAnswer]);
  return /*#__PURE__*/_jsxs("div", {
    children: [image && /*#__PURE__*/_jsx(UIHoverlay, {
      className: "m-y-8 vr-hidden",
      foregroundContent: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        alignSelf: "center",
        direction: "column",
        justify: "center",
        onClick: () => window.open(image, '_blank'),
        style: {
          cursor: 'pointer'
        },
        children: [/*#__PURE__*/_jsx("h2", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.quiz.openImage"
          })
        }), /*#__PURE__*/_jsx(UIIcon, {
          name: "externalLink",
          size: "md"
        })]
      }),
      children: /*#__PURE__*/_jsx(UIImage, {
        alt: I18n.text('learningCenter.quiz.image'),
        className: "question__image",
        "data-test-id": "quiz-question-image",
        src: image
      })
    }), /*#__PURE__*/_jsx(QuestionAnswerList, {
      answers: answers,
      multipleSelection: type === 'MULTIPLE_CHOICE_SELECT_MANY',
      onSelectAnswer: handleSelectAnswer,
      questionId: id,
      selectedAnswerIds: selectedAnswerIds
    })]
  });
};
export default Question;